<div class="card height-equal">
  <div class="card-body d-flex justify-content-center">
    <nav aria-label="Page navigation example">
      <ul class="pagination pagination-dark pagin-border-dark gap-2">
        <li class="page-item" (click)="previousPage()">
          <a class="page-link rounded-circle" href="javascript:void(0)" aria-label="Previous">
            <span aria-hidden="true">«</span>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        @for (page of pageNumbers; track page) {
          @if (selectedPage==page 
          || page==(pageNumbers.length) 
          || selectedPage==(page-1) 
          || selectedPage==(page+1)) {
            @if(page==(pageNumbers.length) && pageNumbers.length>3 && selectedPage!=(pageNumbers.length-1)){
              <div class="mt-2">...</div>
            }
            <li class="page-item" (click)="selectPage(page)">
              <a class="page-link rounded-circle"   href="javascript:void(0)">{{page}}</a>
            </li>
          }
        }
        <li class="page-item" (click)="nextPage()">
            <a class="page-link rounded-circle" href="javascript:void(0)" aria-label="Next">
            <span aria-hidden="true">»</span>
            <span class="sr-only">Next</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>